import { render } from "./SearchExam.vue?vue&type=template&id=dc057b92"
import script from "./SearchExam.vue?vue&type=script&lang=js"
export * from "./SearchExam.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__